import { ICustomerExportParams, ICustomerSearchParams } from './interface';

export const HEAD_TABLE_PROPS = [
  { id: 'id', label: 'ID', align: 'center' },
  { id: 'name', label: 'Họ và tên', align: 'left' },
  { id: 'phoneNumber', label: 'Số điện thoại', align: 'left' },
  { id: 'recentActivty', label: 'Hoạt động gần nhất', align: 'left' },
  { id: 'action', label: 'Action', align: 'left' },
];

export const DEFAULT_SEARCH_VALUE: ICustomerSearchParams = {
  searchBy: '',
  searchText: '',
  recentActivity: '',
};

export const DEFAULT_EXPORT_VALUE: ICustomerExportParams = {
  page: 1,
  limit: 1000,
  searchBy: '',
  searchText: '',
  startDate: '',
  endDate: '',
  fileName: '',
  recentActivity: '',
};
